import { Component, OnDestroy, OnInit } from '@angular/core';
import { Moderation } from 'src/app/classes/moderation';
import { ModerationService } from 'src/app/services/moderation.service';
import { DateCalculationService } from 'src/app/services/date-calculation.service';
import { Router } from '@angular/router';
import { LazyLoadEvent, SelectItem} from 'primeng/api';
import { GpaoService } from 'src/app/services/gpao.service';
import { DialogService, DynamicDialogRef } from 'primeng';
import { AffectationComponent } from './affectation/affectation.component';
import { EncryptionService } from 'src/app/services/encryption.service';

@Component({
  selector: 'app-moderation',
  templateUrl: './moderation.component.html',
  styleUrls: ['./moderation.component.css'],
  providers: [DialogService]
})
export class ModerationComponent implements OnInit {

  //Check si les données ont été loadés
  dataLoaded:boolean = false;

  loading:boolean = false;
  moderationLoading:boolean = false ;
  cqLoading:boolean = false ;

  cqs : Moderation[];
  cqsSource : Moderation[];
  cqsTotalRecords : number;
  moderations : Moderation[];
  moderationsSource : Moderation[];
  moderationCols: any[];
  moderationsTotalRecords : number;
  cqCols: any[];
  modePush: boolean;
  showModeration: boolean;
  showCQ: boolean;

  typeFilter : SelectItem[] = [
    {label : 'INITIALE', value : 'INITIALE' },
    {label : 'R', value : 'R' },
    {label : 'R1', value : 'R1' },
    {label : 'R2', value : 'R2' }
  ];

  complexteFilter : SelectItem[] = [
    {label : 'FORTE', value : 3 },
    {label : 'MOYENNE', value : 2 },
    {label : 'FAIBLE', value : 1 }
  ];

  disabled: boolean = false;

  utilisateur : any;

  ref:DynamicDialogRef;

  constructor(private moderationService : ModerationService, private encryptService:EncryptionService, private dateService : DateCalculationService, private router: Router, private gpaoService: GpaoService, private dialogService : DialogService) { }
  
 
  ngOnInit(): void {
    this.loading = true;

    let getLoadings = {
      cq : false,
      moderations : false
    };

    this.moderationService.getPtlEnAttenteCq().subscribe((value) => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);

      }else {
        this.cqs;
        let moderationList = value["data"];
        this.cqs =  this.formatArray(moderationList);
        this.cqs.sort(this.sortCqByDuree);
        this.cqsTotalRecords = this.cqs.length;
        getLoadings.cq = true;

        if(getLoadings.cq === true && getLoadings.moderations === true) {
          this.loading = false;
          this.dataLoaded = true;
        } 
      }
    });

    this.utilisateur = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
    this.moderationService.getCurrentModerationLibresDuplicated(this.utilisateur.matricule).subscribe((value) => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        this.moderations = [];
        let moderationList = value["data"];
        this.moderationsSource = this.formatArray(moderationList);
        this.moderationsSource.sort(this.sortByDuree);
        this.moderationsTotalRecords = this.moderationsSource.length;
        getLoadings.moderations = true;
        console.log("moderations azo")
        if(getLoadings.cq === true && getLoadings.moderations === true) {
          this.loading = false;
          this.dataLoaded = true;
        } 
      }
    });
    
    this.moderationCols = [
      {field: 'typePtl', header: 'Type'},
      {field: 'idComplexite', header: 'Complexité'},
      {field: 'numPointAccueil', header: 'Login PTL'},
      {field: 'idBonPlan', header: 'ID Bon Plan'},
      {field: 'operateur', header: 'Matricule opérateur'},
      {field: 'etat', header:'Etat'},
      {field: 'tempsRestant', header: 'Temps restant'}
    ]

    this.cqCols = [
      {field: 'typePtl', header: 'Type'},
      {field: 'idComplexite', header: 'Complexité'},
      {field: 'numPointAccueil', header: 'Login PTL'},
      {field: 'idBonPlan', header: 'ID Bon Plan'},
      {field: 'responsableCq', header: 'Matricule CQ'},
      {field: 'operateur', header: 'Modérateur'},
      {field: 'etat', header:'Etat'},
      {field: 'tempsRestant', header: 'Temps restant'}
    ]

    if(localStorage.getItem("mode") !== null) {
      if(localStorage.getItem("mode") === "push") {
        this.modePush = true;
      }else {
        this.modePush = false;
      }
    }else {
      this.setMode();
    }
    // SET VIEW
    let id_droit= parseInt(( JSON.parse(this.encryptService.decrypt(localStorage.getItem("user"))).droit ));
    switch (id_droit) {
      case 1:
      {
        this.showCQ = true;
        this.showModeration = true;
        break;
      }
      case 2:
      {
        this.showCQ = true;
        this.showModeration = true;
        break;
      }
      case 3:
      {
        this.showCQ = false;
        this.showModeration = false;
        break;
      }
      case 4:
      {
        this.showCQ = false;
        this.showModeration = true;
        break;
      }
      case 5:
      {
        this.showCQ = true;
        this.showModeration = true;
        break;
      }
      default:
        this.showCQ = false;
        this.showModeration = false;
    }
  }



  loadModerations(event: LazyLoadEvent) {  
      let time = this.dataLoaded ? 500 : 5000;
      this.moderationLoading = true;
      setTimeout(() => {
        console.log(this.moderationsSource)
        if (this.moderationsSource) {
            // filter data
            let filteredRows = this.moderationsSource.filter(row => this.filterField(row, event.filters))
            // sort data
            filteredRows.sort((a, b) => this.compareField(a, b, event.sortField) * event.sortOrder);
            this.moderations = filteredRows.slice(event.first, (event.first + event.rows));
            this.moderationLoading = false;
        } else {
          this.moderationLoading = false;
        }
      }, time);
  

  } 


  loadCqs(event: LazyLoadEvent) {
    let time = this.dataLoaded ? 5000 : 500;  
    this.cqLoading = true;
    
    setTimeout(() => {
        if (this.cqsSource) {
          // filter data
          let filteredRows = this.cqsSource.filter(row => this.filterField(row, event.filters))
          // sort data
          filteredRows.sort((a, b) => this.compareField(a, b, event.sortField) * event.sortOrder);
          this.cqs = filteredRows.slice(event.first, (event.first + event.rows));
          this.cqLoading = false;
        } else {
          this.cqLoading = false;
        }
    }, time);

  } 



  filterField(row, filter) {
    let isInFilter = false;
    let noFilter = true;

    for (var columnName in filter) {
      if (row[columnName] == null) {
        return;
      }
      noFilter = false;
      let rowValue: String = row[columnName].toString().toLowerCase();
      let filterMatchMode: String = filter[columnName].matchMode;
      if (filterMatchMode.includes("contains") && rowValue.includes(filter[columnName].value.toLowerCase())) {
        isInFilter = true;
      } else if (filterMatchMode.includes("startsWith") && rowValue.startsWith(filter[columnName].value.toLowerCase())) {
        isInFilter = true;
      } else if (filterMatchMode.includes("in") && filter[columnName].value.includes(rowValue)) {
        isInFilter = true;
      }
    }

    if (noFilter) { isInFilter = true; }

    return isInFilter;
  }

  compareField(rowA, rowB, field: string): number {
    if (rowA[field] == null) return 1; // on considère les éléments null les plus petits
    if (typeof rowA[field] === 'string') {
      return rowA[field].localeCompare(rowB[field]);
    }
    if (typeof rowA[field] === 'number') {
      if (rowA[field] > rowB[field]) return 1;
      else return -1;
    }
  }


  /**
   * Cette fonction permet de formatter le tableaux retourné par l'api en format utilisable pour le tableau
   * type => 1: moderation, 2 : cq
   * @param moderationList 
   */
  formatArray(moderationList : any[]) {
    let cumulArray : Moderation[] = [];

    moderationList.forEach(item => {
      let dateDelai: Date ;
      let now:Date = new Date();
      let delaiRestant:string;
      
      if(item.type_ptl === "INITIALE") {
        dateDelai = this.dateService.calculDelay(item.date_arrivee, 24);
      } else {
        dateDelai = this.dateService.calculDelay(item.date_arrivee, 2);
      }
      
      if(now.getTime() > dateDelai.getTime()){
        delaiRestant = "00:00";
      }else {
        delaiRestant = this.dateService.getDifference(now, dateDelai);
      }

      let mod : Moderation = {
        idModeration : item.id_moderation,
        numPointAccueil : item.num_point_accueil,
        numConvention : item.num_convention,
        numEncaisseur : item.num_encaisseur,
        typePtl : item.type_ptl,
        operateur : item.operateur,
        responsableCq : item.id_responsable_cq,
        etat : item.etat,
        idBonPlan : item.id_bon_plan,
        tempsRestant : delaiRestant,
        idEtat : item.id_etat,
        priorite : item.priorite,
        idComplexite : item.id_complexite,
        complexite : item.libelle_complexite,
        matriculeDenied : item.matricule_denied
      };

      cumulArray.push(mod);
    });

    return cumulArray;
  }


  /**
   * Ordre des fiches par durée
   */
  sortByDuree(a : Moderation, b : Moderation) {
    if(a.tempsRestant > b.tempsRestant ) {
      return 1;
    } else if (a.tempsRestant < b.tempsRestant ){
      return -1;
    } else {
      return 0;
    }
  }


  /**
   * Ordre des fiches en CQ
   * @param a 
   * @param b 
   */
  sortCqByDuree(a : Moderation, b : Moderation) {
    if(a.priorite > b.priorite) {
      return 1;
    } else {
      if(a.tempsRestant > b.tempsRestant ) {
        return 1;
      } else if (a.tempsRestant < b.tempsRestant ){
        return -1;
      } else {
        return 0;
      }
    }
  }


  /**
   * Les deux fonctions suivantes permettent d'enlever les lignes dans le tableau cq ou moderation
   * @param idModeration 
   */
  removeFromModerationList(idModeration : number){
    let index  = this.moderations.findIndex(current => current.idModeration === idModeration);
    this.moderations = this.moderations.filter((val, i) =>  i != index);
  }


  removeFromCqList(idModeration : number){
    let index  = this.cqs.findIndex(current => current.idModeration === idModeration);
    this.cqs = this.cqs.filter((val, i) =>  i != index);
  }


  /**
   * Redirige vers la page de modération des contenus
   */
  moderationLink(mod : Moderation) {
    this.disabled = true;
    let user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
    let options = {
      moderation : mod.idModeration,
      operateur : user.matricule,
      action : 1,
      etat : mod.idEtat
    };

    
    this.moderationService.changerEtat(options).subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
        if(value["cause"] === "PTL déjà pris") {
          alert("déjà pris");
          this.removeFromModerationList(mod.idModeration);
        }
        this.disabled = false;
      } else {
      
        this.router.navigate(["/traitement", mod.idModeration] );
      }
    });
  }


  previsualiser(idModeration : number) {
    let link = "" + window.location.origin + "/visualisation/" + idModeration;
    this.openLinkOnNewTab(link); 
  }

  /**
   * Permet d'ouvrir le lien dans un nouvel onglet
   */
  openLinkOnNewTab(link : string ){
    var url = encodeURI(link);
    window.open(url, "_blank");
  }



  /**
   * Redirection vers lien CQ
   */
  cqLink(idModeration : number,etat : number) {
    this.disabled = true;
    let user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
    let options = {
      moderation : idModeration,
      operateur : user.matricule,
      action : 4,
      etat : etat
    };

    this.moderationService.changerEtat(options).subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
        if(value["data"] === "PTL déjà pris") {
          alert("déjà pris");
          this.removeFromCqList(idModeration);
        }
        this.disabled = false;
      } else {
        this.router.navigate(["/cq", idModeration] );
      }
    });
  }


  panelStyle() : object {
    return {
      "min-height" : "500px;"
    };
  }

  setMode() {
    if(this.modePush) {
      localStorage.setItem("mode", "push");
    }else {
      localStorage.setItem("mode", "pull");
    }
  }



  /**
   * Retourne si la fiche est moderable
   * @param etat 
   */
  moderable(etat : number) {

    if(etat === 1 || etat === 7 || etat === 15 || etat === 10 || etat === 20) {
      return true;
    }

    return false;
  }



  /**
   * Retourne si on peut traiter la fiche en cq
   * @param etat 
   */
  traitableCq(etat : number) {
    if(etat === 3 || etat === 16 || etat === 13 || etat === 17) {
      return true;
    }

    return false;
  } 


  getComplexite(idComplexite: number) {
    switch(idComplexite) {
      case(1) : {
        return 'FAIBLE';
        break;
      }
      case(2) : {
        return 'MOYENNE';
        break;
      }
      case(3) : {
        return 'FORTE';
        break;
      }
    }
  }


  canAffect() {
    return (parseInt(this.utilisateur.droit) === 1 || parseInt(this.utilisateur.droit) === 2 || parseInt(this.utilisateur.droit) === 5) ? true : false;
  }

  canVisualize(){
    if(parseInt(this.utilisateur.droit) === 1) return true;
    else return false;
  }


  affecterFiche(idModeration:number) {
    let matricule = parseInt(this.utilisateur.matricule);

    this.moderationService.affecterFiche(matricule, idModeration).subscribe( value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
      } else {
        alert('Affectation effectuée');
        this.removeFromModerationList(idModeration);
      }
    });
  }


  showListePersonne(moderation:Moderation) {
    const ref = this.dialogService.open(AffectationComponent, {
      header: 'Affecter la fiche n° ' + moderation.numPointAccueil,
      width: '40%',
      data: {
        moderation:moderation
      }
    });


    ref.onDestroy.subscribe(() => {
      this.moderationService.getCurrentModerationLibresDuplicated(this.utilisateur.matricule).subscribe((value) => {
        if(value["status"] !== "success"){
          console.log("Une erreur dans la requête:" + value["cause"]);
        }else {
          this.moderations = [];
          let moderationList = value["data"];
          this.moderations = this.formatArray(moderationList);
          this.moderations.sort(this.sortByDuree);
        }
      });
    });
  }
  
}
